<template>
  <div>
    <form-label v-if="label" class="uk-form-label" :text="fieldLabel" :hint="fieldHint" :for="id"></form-label>
    <div class="uk-form-controls">
      <input v-if="name === 'numero_persone'" class="uk-input" :class="{'uk-form-danger': isDanger, 'uk-form-success': isSuccess}" :type="type" :id="id" :name="name" :disabled="!enabled" v-model="fieldValue" @input="doValidate" @blur="triggerChangeAndValidate" :placeholder="placeholder" min="1">
      <input v-else class="uk-input" :class="{'uk-form-danger': isDanger, 'uk-form-success': isSuccess}" :type="type" :id="id" :name="name" :disabled="!enabled" v-model="fieldValue" @input="doValidate" @blur="triggerChangeAndValidate" :placeholder="placeholder" :min="type == 'number' ? min : false">
    </div>
    <form-error v-for="(error, index) in errors" :key="index" :error="error"></form-error>
  </div>

</template>

<script>
  import FormField from "rubinred/forms/js/mixins/FormField";

  export default {
    mixins: [FormField],
    props: {
      type: {
        type: String,
        default: 'text'
      },
      placeholder: {
          type: String,
          default: ''
      },
      min: {
          type: String,
      }
    }
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/museo/extensions/rubinred/forms/assets/js/components/FormInput.vue